module.exports = __webpack_public_path__ + "static/media/people-star-fill-primary.e070bcab.svg";